(() => {
  'use strict';

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-af4-compare-slider]').forEach((slider) => {
      if (slider.dataset.af4CompareReady === 'true') return;
      slider.dataset.af4CompareReady = 'true';
      const range = slider.querySelector('[data-af4-compare-range]');
      if (!range) return;
      const update = () => slider.style.setProperty('--af4-position', `${range.value}%`);
      const start = () => slider.classList.add('is-interacting');
      const stop = () => slider.classList.remove('is-interacting');
      range.addEventListener('input', () => { start(); update(); });
      range.addEventListener('change', () => { update(); window.setTimeout(stop, 500); });
      range.addEventListener('pointerdown', start);
      range.addEventListener('pointerup', () => window.setTimeout(stop, 500));
      range.addEventListener('touchstart', start, { passive: true });
      range.addEventListener('touchend', () => window.setTimeout(stop, 500), { passive: true });
      update();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
